<template>
  <v-menu
    v-model="menu_ativo"
    :close-on-content-click="false"
    transition="scale-transition"
    :eager="eager"
  >
    <template v-slot:activator="{}">
      <SysBtn :class="contentClass" :size="size" @click="menu_ativo = !menu_ativo">
        <v-icon size="18">mdi-filter</v-icon>
        <span class="ml-1">{{texto_botao_ativador}}</span>
      </SysBtn>
    </template>

    <v-card class="pb-2 w-730 border-gray-500 overflow-y-auto" elevation="10" style="max-height: 95vh">

      <v-card-title class="pl-4 pr-1 py-2">
        <div>
          <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">Selecione o que você deseja considerar na análise</p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = !menu_ativo">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="px-2">
        <slot name="prepend" />

        <template v-if="!ocultar_filtros_fixos">
          <v-checkbox v-model="filtros.fora_de_linha" hide-details class="pb-3">
            <template #label>
              <span class="ml-1 font-15">Produtos fora de linha</span>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.inativo_revenda" hide-details class="pb-3">
            <template #label>
              <span class="ml-1 font-15">Produtos inativos para revenda</span>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.produto_resgatado" hide-details class="pb-3">
            <template #label>
              <div>
                <p class="ma-0 ml-1 font-15">Produtos resgatados</p>
                <p class="ma-0 ml-1 mt-n1 font-12 text-gray-200">
                  Última entrada menor ou igual a 90 dias e estoque zerado por 30 dias antes da última entrada.
                </p>
              </div>
            </template>
          </v-checkbox>

          <v-checkbox v-model="filtros.venda_futura_maior_que_saldo_estoque" hide-details class="pb-4">
            <template #label>
              <Legenda
                titulo="Ocultar itens com Venda Futura maior que o Estoque"
                legenda="Este filtro remove da análise os itens cujo estoque está totalmente comprometido com pedidos já fechados, aguardando apenas a entrega ao cliente. Produtos com estoque maior que os pedidos fechados aparecem normalmente."
              >
                <div>
                  <p class="ma-0 ml-1 font-15">Ocultar itens com Venda Futura maior que o Estoque</p>

                  <p class="ma-0 ml-1 mt-n1 font-12 text-gray-200">
                    Produtos que já foram vendidos e estão aguardando liberação.
                  </p>
                </div>
              </Legenda>
            </template>
          </v-checkbox>

          <div class="ml-2 mr-1">
            <div class="d-flex align-center">
              <div class="w-33-porcento pr-1">
                <v-autocomplete
                  v-model="filtros.primeira_entrada"
                  label="Primeira entrada"
                  :items="selects.dias"
                  item-text="descricao"
                  item-value="valor"
                  outlined
                  multiple
                  clearable
                  hide-details
                  small-chips
                  :height="ALTURA_MINIMA_FILTROS_DIAS"
                />
              </div>

              <div class="w-33-porcento px-1">
                <v-autocomplete
                  v-model="filtros.ultima_entrada"
                  label="Última entrada"
                  :items="selects.dias"
                  item-text="descricao"
                  item-value="valor"
                  outlined
                  multiple
                  clearable
                  hide-details
                  small-chips
                  :height="ALTURA_MINIMA_FILTROS_DIAS"
                />
              </div>

              <div class="w-33-porcento pl-1">
                <v-autocomplete
                  v-model="filtros.idade"
                  label="Idade dos produtos"
                  :items="selects.dias"
                  item-text="descricao"
                  item-value="valor"
                  outlined
                  multiple
                  clearable
                  hide-details
                  small-chips
                  :height="ALTURA_MINIMA_FILTROS_DIAS"
                />
              </div>
            </div>

            <slot name="append">
              <DivisorComLegenda legenda="Filtros de produtos combinados" class="my-5" />
              <TiposProdutoAutocomplete v-model="filtros.tipos_produtos" />

              <DivisorComLegenda legenda="Outros" class="my-5" />

              <div class="d-flex align-center">
                <div class="w-33-porcento pr-2">
                  <SysCompradorAutocomplete
                    v-model="filtros.compradores"
                    label="Compradores"
                    :qtde_visivel_selecionados="1"
                    :ids-segmento="filtros.segmentos"
                    outlined
                    multiple
                    hide-details
                    clearable
                  >
                    <template #selection="{item}">
                      <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.compradores" :item="item" item_value="nome_completo" />
                    </template>
                  </SysCompradorAutocomplete>
                </div>

                <div class="w-33-porcento pr-2">
                  <SysFornecedorAutocomplete
                    v-model="filtros.fornecedores"
                    label="Fornecedores"
                    :qtde-visivel-selecionados="1"
                    :ids-segmento="filtros.segmentos"
                    :ids-comprador="filtros.compradores"
                    outlined
                    multiple
                    hide-details
                    clearable
                  >
                    <template #selection="{item}">
                      <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.fornecedores" :item="item" />
                    </template>
                  </SysFornecedorAutocomplete>
                </div>

                <div class="w-33-porcento">
                  <SysLinhasAutocomplete
                    v-model="filtros.linhas"
                    label="Linhas"
                    :qtde_visivel_selecionados="1"
                    outlined
                    multiple
                    hide-details
                    clearable
                    :autoselecionar_linhas_com_movimento="autoselecionar_linhas_com_movimento"
                    @autoselecionado-linhas-com-movimento="aplicarFiltros"
                  />
                </div>
              </div>

              <div class="d-flex align-center mt-3">
                <div class="w-33-porcento pr-2">
                  <SysSegmentoAutocomplete
                    v-model="filtros.segmentos"
                    label="Segmentos"
                    :qtde-visivel-selecionados="1"
                    outlined
                    multiple
                    hide-details
                    clearable
                  >
                    <template #selection="{item}">
                      <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.segmentos" :item="item" />
                    </template>
                  </SysSegmentoAutocomplete>
                </div>

                <div class="w-33-porcento pr-2">
                  <SysSecaoAutocomplete
                    v-model="filtros.secoes"
                    :qtde_visivel_selecionados="1"
                    label="Seções"
                    outlined
                    multiple
                    hide-details
                    clearable
                  />
                </div>

                <div class="w-33-porcento">
                  <SysCategoriaAutocomplete
                    v-model="filtros.categorias"
                    :qtde_visivel_selecionados="1"
                    label="Categorias"
                    outlined
                    multiple
                    hide-details
                    clearable
                  />
                </div>
              </div>

              <div class="d-flex align-center mt-3">
                <div class="w-33-porcento pr-2">
                  <SysProdutosAutocomplete
                    v-model="filtros.produtos"
                    :qtde_visivel_selecionados="1"
                    label="Produtos"
                    outlined
                    multiple
                    hide-details
                    clearable
                    desabilitar_botao_selecao_todos
                  />
                </div>

                <div class="w-33-porcento pr-2">
                  <SysStatusProduto v-model="filtros.status_produto" />
                </div>

                <div class="w-33-porcento">
                  <SysHistograma v-model="filtros.histogramas" />
                </div>
              </div>

              <div class="d-flex align-center mt-3">
                <div class="w-33-porcento pr-2">
                  <SysAutocomplete
                    v-model="filtros.pedidos_pendentes"
                    label_props="Pedidos Pendentes"
                    :items_props="selects.items_props_produtos_pendentes"
                  />
                </div>

                <div v-if="FILTRO_PRODUTOS_MIX_FILIAL" class="w-33-porcento pr-2">
                  <SysAutocomplete
                    v-model="filtros.produtos_mix_filial"
                    label_props="Produtos Mix Filial"
                    :items_props="selects.items_props_produtos_mix_filial"
                  />
                </div>

                <slot name="pedidos_pendentes.append"></slot>

                <div class="w-33-porcento pr-2">
                  <SysMarcaAutocomplete
                    v-model="filtros.marcas"
                    label="Marcas"
                    :ids-grupo="filtros.grupos"
                    :ids-filial="filtros.filiais"
                    :qtde-visivel-selecionados="1"
                    outlined
                    multiple
                    hide-details
                    clearable
                  />
                </div>
              </div>

              <slot name="append.outros_filtros"></slot>
            </slot>
          </div>
        </template>
      </v-card-text>

      <div class="d-flex px-2">
        <v-spacer />

        <v-btn small color="#042333" dark @click="aplicarFiltros">
          filtrar
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import TiposProdutoAutocomplete from "@/components/indicadores/SysTiposProdutoAutocomplete.vue";
import SysLinhasAutocomplete from "@/components/utils/crud/SysLinhasAutocomplete.vue";
import SysStatusProduto from "@/components/utils/crud/SysStatusProduto.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete
  from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import SysHistograma from "@/components/Eventos/SazonalidadeFinal/Filtros/SysHistograma.vue";
import SysProdutosAutocomplete from "@/components/utils/crud/SysProdutosAutocomplete.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";

export default {
  name: "Filtros",
  components: {
    Legenda,
    SysProdutosAutocomplete,
    SysHistograma,
    SysAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    TextoOutrosFiltrosSelecionadosAutocomplete,
    SysSecaoAutocomplete,
    SysStatusProduto,
    SysLinhasAutocomplete,
    TiposProdutoAutocomplete,
    SysCategoriaAutocomplete,
    SysMarcaAutocomplete,
    DivisorComLegenda
  },
  props: {
    texto_botao_ativador: {
      type: String,
      default: "Filtros"
    },
    contentClass: {
      type: String,
      default: ''
    },
    size: Number,
    ocultar_filtros_fixos: {
      type: Boolean,
      default: false
    },
    eager: Boolean,
    autoselecionar_linhas_com_movimento: Boolean,
  },
  data: () => ({
    menu_ativo: false,
    filtros: {},
    selects: {
      dias: [
        {valor: 1, descricao: '1. Menor que 90 dias'},
        {valor: 2, descricao: '2. Entre 90 e 180 dias'},
        {valor: 3, descricao: '3. Maior que 180 dias'},
      ],
      items_props_produtos_pendentes: [
        { id: 1, descricao: '1. Produtos sem Pedido Pendente' },
        { id: 2, descricao: '2. Produtos com Pedido Pendente' },
      ],
      items_props_produtos_mix_filial: [
        { id: 1, descricao: '1. Produtos Fora do Mix' },
        { id: 2, descricao: '2. Produtos no Mix' },
      ]
    }
  }),
  computed: {
    FILTROS_STORE: {
      get: function () {
        return this.$store.getters['filtrosProdutosDiagnostico/filtros'];
      },
      set: function (valor) {
        this.$store.dispatch('filtrosProdutosDiagnostico/filtros', valor);
      }
    },
    ALTURA_MINIMA_FILTROS_DIAS() {
      const {primeira_entrada, ultima_entrada, idade} = this.filtros;
      return Math.max(primeira_entrada.length, ultima_entrada.length, idade.length, 1) * 37;
    },
    FILTRO_PRODUTOS_MIX_FILIAL() {
      return localStorage.getItem('mix_produtos_filial_ativar_limitacao_visualizacao') === 'S';
    }
  },
  created() {
    this.filtros = {...this.FILTROS_STORE};
  },
  watch: {
    FILTROS_STORE: {
      handler() {
        this.filtros = {...this.FILTROS_STORE};
      },
      deep: true
    }
  },
  methods: {
    aplicarFiltros() {
      this.FILTROS_STORE = {...this.filtros};
      this.menu_ativo = false;
      this.$emit("update:filtros", {filtros: this.filtros})
    }
  }
}
</script>

<style scoped>
</style>
